import Select from '../../../../CMSComponent/Forms/Fields/select'
import { primary_color } from '../../../../Helper/uiHelper'

const TicketEnvironment = ({ environment, isEditMode, setUpdatedData }) => {
  if (isEditMode)
    return (
      <Select
        data={environmentDropdown}
        noCache
        value={environment}
        inputLabel={environment}
        isTable
        onChangeValue={(id, value) => {
          setUpdatedData((data) => {
            return {
              ...data,
              environment: value,
            }
          })
        }}
      />
    )
  return <div className='subtitle1 text-muted'>{environment}</div>
}

const environmentDropdown = {
  component_type: 'fields',
  component_name: 'select',
  name: 'status',
  is_layout: null,
  row_index: null,
  block_index: null,
  col: 6,
  section_rowspan: null,
  field_setting: {
    import: true,
    export: true,
    is_copy_allowed: null,
    depend_fields: null,
    disable_if: [],
    textarea: false,
  },
  cms_value: 'Environment',
  permission: null,
  field_id: 'environment',
  cms_key: 'Environment',
  cms_tooltip: null,
  component_call_data_connection: {
    component_type: 'data_connection',
    component_name: 'manual',
    default_options: ['In Development', 'In QA', 'Live3', 'Production'],
  },
  selected_value: null,
  disabled: false,
  hidden: false,
  search: false,
  hide_from_grid: false,
  background_color: false,
  component_call_validation: null,
  component_call_actions: null,
  component_call_fields: null,
  format: {
    size: 12,
    searchable: false,
    is_multi_select: false,
  },
  place_holder: null,
  cms_sub_heading: '',
}

export default TicketEnvironment
